import { useMemo } from 'react';
import { AircraftIcon } from '@icons';
import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import { TmdxJetAviaLeg } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';

type TmdxAviaInfoProps = {
  leg: TmdxJetAviaLeg;
  showTailNumber?: boolean;
};

export const TmdxAviaInfo = ({ leg, showTailNumber = false }: TmdxAviaInfoProps) => {
  const { Aircraft: aircraftsList } = useRouteResources();

  const currentAircraft = useMemo(() => {
    const currentAircraftResource = leg.resources.find((r) => r.resourceType === CaseResourceType.Aircraft);
    return aircraftsList?.find((a) => a.resourceId === currentAircraftResource?.resourceId);
  }, [leg.resources, aircraftsList]);

  const aircraftNumber = currentAircraft?.data?.registration ? currentAircraft.data.registration : '';
  const uniqueAircraftNumber = useMemo(() => {
    if (!currentAircraft) return '';
    const currentRegistration = currentAircraft.data?.registration;
    const uniqueRegistrations = new Set<string>();

    aircraftsList.forEach((aircraft) => {
      if (aircraft.data?.registration) {
        uniqueRegistrations.add(aircraft.data.registration);
      }
    });

    const sortedRegistrations = Array.from(uniqueRegistrations).toSorted((a, b) => a.localeCompare(b));
    const currentAircraftIndex = currentRegistration ? sortedRegistrations.indexOf(currentRegistration) : -1;
    return currentAircraftIndex !== -1 ? currentAircraftIndex + 1 : '';
  }, [aircraftsList, currentAircraft]);

  return (
    <div className="flex items-center gap-1">
      {aircraftsList.length > 1 && aircraftNumber && (
        <span className="size-4 text-x-sm text-white bg-base-10 rounded-3xl flex items-center justify-center">
          {uniqueAircraftNumber}
        </span>
      )}
      <AircraftIcon width={24} height={24} />
      {showTailNumber && <span className="text-m-sb text-base-20 pt-0.5">{currentAircraft?.data?.registration}</span>}
    </div>
  );
};
